import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from './../_services';
import { UserData } from '@app/_models';
import { RouteInfo } from '@app/_models/Portal/Menu';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(private router: Router, private accountService: AccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.accountService.userValue;

    if (user) {
      return true;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/publico/Login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
@Injectable({ providedIn: 'root' })
export class AuthGuardChild  {
  constructor(private router: Router, private accountService: AccountService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const menuItems: RouteInfo[] = JSON.parse(
      localStorage.getItem('menuItems')
    );
    const user = this.accountService.userValue;
    if (user) {
      let hasPermissions: boolean = menuItems.some((item: RouteInfo) => {
        if (item.path && item.path === `${state.url}`) {
          return true;
        }
        return item.children.some((item: any) => {
          if (item.path === `${state.url}`) {
            return true;
          }
          return false;
        });
      });     
      return hasPermissions;
    }
    // not logged in so redirect to login page with the return url
    this.router.navigate(['/publico/Login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
const ValidatePermision = (route: Router, path: string): boolean => {
  const menuItems: RouteInfo[] = JSON.parse(localStorage.getItem('menuItems'));

  const hasPermissions = menuItems.some((item: RouteInfo) => {
    console.log(
      '🚀 ~ ValidatePermision ~ item:',
      item?.path,
      '===',
      `/${path}`
    );
    if (item?.path === `/${path}`) {
      return true;
    }
    return false;
  });
  console.log('🚀 ~ hasPermissions ~ hasPermissions:', hasPermissions);
  return hasPermissions;
};
